import React, { useState } from 'react'
import { Button, Form, Input, Modal, Space, message } from 'antd'
import { post } from '../lib/request'
import { errMsg } from '../lib/api'

/**
 * 统一审批弹窗（审核中心双 tab 复用，拍板4）
 * 提交 {action: 'approve'|'reject', note} 至 reviewUrl；
 * 后端统一响应 {status:'approved'|'rejected', reviewNote}
 */
interface Props {
  title: string
  reviewUrl: string | null
  targetLabel?: string
  onClose: () => void
  onDone: () => void
}

const ReviewActions: React.FC<Props> = ({ title, reviewUrl, targetLabel, onClose, onDone }) => {
  const [action, setAction] = useState<'approve' | 'reject'>('approve')
  const [form] = Form.useForm<{ note: string }>()
  const [loading, setLoading] = useState(false)

  const open = (a: 'approve' | 'reject') => {
    setAction(a)
    form.resetFields()
  }

  const submit = async () => {
    if (!reviewUrl) return
    const values = await form.validateFields()
    if (action === 'reject' && !values.note?.trim()) {
      form.setFields([{ name: 'note', errors: ['驳回时须填写原因'] }])
      return
    }
    setLoading(true)
    try {
      await post(reviewUrl, { action, note: values.note })
      message.success(action === 'approve' ? '已通过' : '已驳回')
      onClose()
      onDone()
    } catch (err: unknown) {
      message.error(errMsg(err, '审批失败'))
    } finally {
      setLoading(false)
    }
  }

  return (
    <Modal
      title={title}
      open={!!reviewUrl}
      onCancel={onClose}
      footer={null}
      destroyOnClose
    >
      {targetLabel && (
        <p style={{ marginTop: 0, color: '#7F8C8D', fontSize: 13 }}>审批对象：{targetLabel}</p>
      )}
      <Space style={{ marginBottom: 12 }}>
        <Button
          type={action === 'approve' ? 'primary' : 'default'}
          onClick={() => open('approve')}
          style={{ minHeight: 44 }}
        >
          通过
        </Button>
        <Button
          danger={action === 'reject'}
          type={action === 'reject' ? 'primary' : 'default'}
          onClick={() => open('reject')}
          style={{ minHeight: 44 }}
        >
          驳回
        </Button>
      </Space>
      <Form form={form} layout="vertical">
        <Form.Item
          name="note"
          label={action === 'reject' ? '驳回原因（必填，留痕）' : '审批备注（可选，留痕）'}
        >
          <Input.TextArea rows={3} placeholder={action === 'reject' ? '例：申请人信息与花名册不符' : '例：信息核实无误'} />
        </Form.Item>
      </Form>
      <Button block type="primary" loading={loading} onClick={submit} style={{ minHeight: 44 }}>
        确认{action === 'approve' ? '通过' : '驳回'}
      </Button>
    </Modal>
  )
}

export default ReviewActions
